import { render, staticRenderFns } from "./similar.vue?vue&type=template&id=638c5c46&scoped=true"
import script from "./similar.vue?vue&type=script&lang=js"
export * from "./similar.vue?vue&type=script&lang=js"
import style0 from "./similar.vue?vue&type=style&index=0&id=638c5c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638c5c46",
  null
  
)

export default component.exports